import React from 'react';
import UsersResults from '../Users/UsersResults';
// import Counter from './Counter';
// import Images from '../Images/image1.jpg';

const Home = () => {
  

  return (
    <div>
      {/* <Counter /> */}
      <UsersResults />
    </div>
  );
};

export default Home;
